var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceCzk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "891.8 0 1125.1 1350.2",
    enableBackground: "new 891.8 0 1125.1 1350.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 919.5,
    y: 21.8,
    width: 1059.6,
    height: 1305.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#322B29",
    d: "M1527.1,1194.6H1000c-44.4,0-80.5-35.8-80.5-79.8V101.6 c0-44,36.1-79.8,80.5-79.8h490.5c4.3,0,8.4,1.6,11.5,4.6l307.9,293.3c3.3,3.1,5.1,7.4,5.1,11.9V868c0,9.1-7.4,16.4-16.6,16.4 c-9.2,0-16.6-7.4-16.6-16.4V338.6l-298-283.9H1000c-26.1,0-47.3,21-47.3,46.9v1013.2c0,25.8,21.2,46.8,47.3,46.8h527.1 c9.2,0,16.6,7.4,16.6,16.5C1543.7,1187.3,1536.3,1194.6,1527.1,1194.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 919.5,
    y: 21.8,
    width: 1059.6,
    height: 1305.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#322B29",
    d: "M1798.4,348h-244c-44.4,0-80.5-35.8-80.5-79.8V38.3c0-9.1,7.4-16.5,16.6-16.5 s16.6,7.4,16.6,16.5v229.9c0,25.8,21.2,46.8,47.3,46.8h244c9.2,0,16.6,7.4,16.6,16.5S1807.5,348,1798.4,348"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 919.5,
    y: 21.8,
    width: 1059.6,
    height: 1305.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_6_)",
    fill: "#322B29",
    d: "M1734.5,875.5c-116.6,0-211.4,94-211.4,209.5c0,115.6,94.9,209.7,211.4,209.7 c116.6,0,211.4-94.1,211.4-209.7C1945.9,969.5,1851,875.5,1734.5,875.5 M1734.5,1327.6c-134.9,0-244.6-108.8-244.6-242.6 c0-133.7,109.7-242.5,244.6-242.5s244.6,108.8,244.6,242.5C1979.1,1218.8,1869.3,1327.6,1734.5,1327.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 919.5,
    y: 21.8,
    width: 1059.6,
    height: 1305.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_8_)",
    fill: "#322B29",
    d: "M1666,524h-622.9c-9.2,0-16.6-7.4-16.6-16.4s7.4-16.5,16.6-16.5H1666 c9.2,0,16.6,7.4,16.6,16.5S1675.1,524,1666,524"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 919.5,
    y: 21.8,
    width: 1059.6,
    height: 1305.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_10_)",
    fill: "#322B29",
    d: "M1666,648.7h-622.9c-9.2,0-16.6-7.4-16.6-16.4c0-9.1,7.4-16.4,16.6-16.4H1666 c9.2,0,16.6,7.4,16.6,16.4C1682.6,641.4,1675.1,648.7,1666,648.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 919.5,
    y: 21.8,
    width: 1059.6,
    height: 1305.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_12_)",
    fill: "#322B29",
    d: "M1366.5,773.5h-323.4c-9.2,0-16.6-7.4-16.6-16.4c0-9.1,7.4-16.5,16.6-16.5 h323.4c9.2,0,16.6,7.4,16.6,16.5C1383.1,766.1,1375.7,773.5,1366.5,773.5"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1553.6918 1158.1764)",
    fontFamily: "'BrandonGrotesque-Bold'",
    fontSize: 190
  }, "CZK")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceCzk);
export default __webpack_public_path__ + "static/media/invoiceCZK.6d3d37c526e236c392b39595f40febed.svg";
export { ForwardRef as ReactComponent };